import { DescriptionPage_LearningProductType as ProductVariant } from '__generated__/graphql-types';

export type ProductVariantValue = (typeof ProductVariant)[keyof typeof ProductVariant];

const getIdToPrefixedStringKey = (id: string, productVariant: ProductVariantValue) => {
  // escape each ~ in the id with !~, but each tilde has one more ! than the previous one
  // ex: s12n~child~asdf~ghjkl -> s12n~child!~asdf!!~ghjkl
  // this is needed for proper stringkey formatting:
  // https://github.com/webedx-spark/shared-java-application-libraries/blob/main/libraries/client/src/main/java/org/coursera/common/clients/stringkey/README.md#records
  const parts = id.split('~');
  const result = parts.map((part, i) => {
    if (i === 0) return part;
    const exclamations = '!'.repeat(i);
    return `${exclamations}~${part}`;
  });
  const escapedId = result.join('');

  let prefix = '';
  if (productVariant === ProductVariant.Course) prefix = 'course';
  else prefix = 's12n';

  return `${prefix}~${escapedId}`;
};

export default getIdToPrefixedStringKey;
